/*
 * The windowed list's own words: the way back to the newest row, which is what every list says when
 * it has nothing more particular to say. What is new, and what is loading above, a surface says in
 * its own nouns ("5 new messages", "Loading earlier messages …") through `WindowedList`'s
 * `newLabel` and `loadingOlderLabel`.
 */

export const en = {
	"list.jumpToLatest": "Jump to the latest",
} as const satisfies Record<string, string>
